import $ from 'jquery'
export default {
  mounted () {
    $('body').addClass('admin')
    $('html, body').animate({ scrollTop: 0 }, 'slow')
  },
  methods: {

  },
  detroyed () {
    $('body').removeClass('admin')
  }
}



// WEBPACK FOOTER //
// ./src/mixins/RestauranteLogged.js